import {
  StyleSheet,
  Text,
  View,
  FlatList,
  TouchableOpacity,
  SafeAreaView,
  Dimensions,
  PixelRatio,
  ActivityIndicator,
} from "react-native";
import React from "react";
import Colours from "../../utils/Colours";
import { Image } from "expo-image";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useQuery } from "@tanstack/react-query";
import { useNavigation } from "@react-navigation/native";

/* =========================
   Dynamic Responsive Helpers
========================= */

const { width, height } = Dimensions.get("window");

const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;
  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

/* =========================
   Component
========================= */

const ShowsListPage = ({
  //   showsData = [
  //     {
  //       _id: "1",
  //       caption: "Live DJ Night with DJ Neptune",
  //       date: "25 Jan 2026",
  //       time: "8:00 PM",
  //       location: "Pompay Rooftop",
  //       image: "https://images.unsplash.com/photo-1513151233558-d860c5398176",
  //     },
  //   ],
  onJoinBid,
}) => {
  const navigation = useNavigation();

  const axiosPrivate = useAxiosPrivate();

  const getAllShowsData = async () => {
    //console.log("this");
    const response = await axiosPrivate.get(`/allShows/allShows/`);
    //console.log("All shows;", response.data.data);
    return response.data.data;
  };

  const {
    data: showsData,
    isLoading: isLoadingShows,
    isError: isError2,
  } = useQuery({
    queryKey: ["showsData"],
    queryFn: getAllShowsData,
  });

  const renderShowItem = ({ item }) => {
    if (!item) return null;

    return (
      <View style={styles.showCard}>
        {/* Show Image */}
        <Image
          source={{ uri: item?.image }}
          style={[styles.showImage, { backgroundColor: "#d6d4d4ff" }]}
          contentFit="cover"
        />

        {/* Content */}
        <View style={styles.contentContainer}>
          <Text style={styles.showTitle}>{item?.showCaption}</Text>

          <View style={styles.metaRow}>
            <Text style={styles.metaLabel}>Date:</Text>
            <Text style={styles.metaValue}>
              {item?.showAt ? new Date(item.showAt).toLocaleDateString() : "N/A"}
            </Text>
          </View>

          <View style={styles.metaRow}>
            <Text style={styles.metaLabel}>Time:</Text>
            <Text style={styles.metaValue}>
              {item?.showAt
                ? new Date(item.showAt).toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })
                : "N/A"}
            </Text>
          </View>

          <View style={styles.metaRow}>
            <Text style={styles.metaLabel}>Location:</Text>
            <Text style={styles.metaValue}>{item?.location}</Text>
          </View>

          {/* Join Bid */}
          <TouchableOpacity
            style={styles.joinBidButton}
            // onPress={() => {
            //   navigation.navigate("owningTable", {
            //     listData: item,
            //   });
            // }}

            onPress={() => {
              navigation.navigate("howToSpend", {
                listData: item,
              });
            }}
          >
            <Text style={styles.joinBidText}>Join the Bid</Text>
          </TouchableOpacity>
        </View>
      </View>
    );
  };

  return (
    <>
      {isLoadingShows ? (
        <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
          <ActivityIndicator size={"large"} color={Colours.PRIMARY} />
        </View>
      ) : (
        <View style={styles.container}>
          <View style={styles.headerContainer}>
            <Text style={styles.headerTitle}>Available Shows</Text>
            <Text style={styles.headerSubtitle}>
              Join the bid to reserve a meeza table for your favorite show
            </Text>
          </View>

          <View style={{ paddingBottom: dynamicSpacing(30) }}>
            {showsData && showsData.length > 0
              ? showsData.map((showItem) => renderShowItem({ item: showItem }))
              : null}
          </View>

          {/* <FlatList
            data={showsData}
            keyExtractor={(item) => item._id}
            renderItem={renderShowItem}
            scrollEnabled={false}
            showsVerticalScrollIndicator={false}
            contentContainerStyle={{ paddingBottom: dynamicSpacing(30) }}
          /> */}
        </View>
      )}
    </>
  );
};

export default ShowsListPage;

/* =========================
   Styles
========================= */

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colours.LIGHTEST,
    //padding: dynamicSpacing(15),
  },

  headerContainer: {
    marginBottom: dynamicSpacing(15),
  },

  headerTitle: {
    fontSize: dynamicFontSize(18),
    fontFamily: "Sen-Bold",
    color: Colours.PRIMARY,
  },

  headerSubtitle: {
    fontSize: dynamicFontSize(13),
    fontFamily: "Sen-Regular",
    color: Colours.DARKLIGHTGRAY,
    marginTop: dynamicSpacing(5),
  },

  showCard: {
    backgroundColor: "white",
    borderRadius: dynamicSize(15),
    marginBottom: dynamicSpacing(15),
    overflow: "hidden",
    elevation: 2,
  },

  showImage: {
    width: "100%",
    height: dynamicSize(180),
  },

  contentContainer: {
    padding: dynamicSpacing(15),
  },

  showTitle: {
    fontSize: dynamicFontSize(16),
    fontFamily: "Sen-Bold",
    color: Colours.DARKGRAY,
    marginBottom: dynamicSpacing(8),
  },

  metaRow: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: dynamicSpacing(4),
  },

  metaLabel: {
    fontSize: dynamicFontSize(13),
    fontFamily: "Sen-Regular",
    color: Colours.DARKLIGHTGRAY,
    marginRight: dynamicSpacing(5),
  },

  metaValue: {
    fontSize: dynamicFontSize(13),
    fontFamily: "Sen-Regular",
    color: Colours.DARKGRAY,
  },

  joinBidButton: {
    marginTop: dynamicSpacing(12),
    backgroundColor: Colours.PRIMARY,
    paddingVertical: dynamicSpacing(10),
    borderRadius: dynamicSize(50),
    alignItems: "center",
  },

  joinBidText: {
    color: "#FFFFFF",
    fontSize: dynamicFontSize(14),
    fontFamily: "Sen-Bold",
  },
});
